<template>
  <div class="chooose_group">
    <div class="layerWrap">
      <div class="layer"></div>
      <div class="group_3">
        <div class="infoWrap"><span class="info">请选择审批原则</span></div>
          <div class="block_approve">
            <label class="label-checkbox item-content">
              <input type="radio" class="radio-input-attr"  name="attr_approve" value="">
              <div class="item-media group" @click="updateApproveType(0)">
                <i class="icon icon-form-checkbox i-style"></i>
                <span class="info_2">不设限额</span>
              </div>
            </label>
          </div>
          <div class="block_approve">
            <label class="label-checkbox item-content">
              <input type="radio" class="radio-input-attr"  name="attr_approve" value="">
              <div class="item-media group" @click="updateApproveType(1)">
                <i class="icon icon-form-checkbox i-style"></i>
                <span class="info_2">限额审批</span>
                <div class="inputWrap">
                  <input v-if="setApproveType === setSinglestrokeApproveType" class="input_text" id="threshold" @blur="resetWindow" @click.stop v-model.trim="approve.approveThreshold" type="text" placeholder="请输入金额">
                  <input v-if="setApproveType === setmouthApproveType" class="input_text" id="threshold" @blur="resetWindow" @click.stop v-model.trim="approve.monthlyLimit" type="text" placeholder="请输入金额">
                </div>
              </div>
            </label>
          </div>

        <div class="block_tagWrap">
          <div class="tagWrap research-background-color" @click="updateMemberApproveType()"><span class="tag">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      approve: {
        approveType: this.memberDetail && this.memberDetail.approveType,
        approveThreshold: this.memberDetail && this.memberDetail.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.approveThreshold : '',
        monthlyLimit: this.memberDetail && this.memberDetail.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.monthlyLimit : ''
      },
      setSinglestrokeApproveType: EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: EMKT.CONSTANT_ALL_APPROVETYPE,
      settype: 0
    }
  },
  props: [
    'memberDetail', 'setApproveType'
  ],
  computed: {
    ...mapGetters([
      'researchGroupDetailList', 'displayChosenResearchGroup'
    ])
  },
  methods: {
    updateApproveType (data) {
      this.settype = data
      this.approve.approveType = EMKT.CONSTANT_APPROVETYPE_THRESHOLD
      this.setApproveType === EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE ? (data === 0 ? this.approve.approveThreshold = '' : '') : (data === 0 ? this.approve.monthlyLimit = '' : '')
    },
    updateMemberApproveType () {
      if (this.validateInfo()) {
        console.log('setApproveType:' + this.setApproveType)
        this.$emit('updateMemberApproveType', this.approve, this.setApproveType)
        this.$emit('toggleShow')
      }
    },
    validateInfo () {
      console.log(this.approve)
      if (this.setApproveType === EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE) {
        this.approve.monthlyLimit = undefined
      }
      if (this.setApproveType === EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE) {
        this.approve.approveThreshold = undefined
      }
      if (this.approve.approveType === undefined) {
        $.toast('请设置审批原则')
        return false
      }
      if (this.approve.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD && this.settype === 1 && ((!this.approve.approveThreshold && this.setApproveType === EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE) || (!this.approve.monthlyLimit && this.setApproveType === EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE))) {
        $.toast('请输入审批限额')
        return false
      }
      if (this.approve.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD && this.settype === 1 && ((this.setApproveType === EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE && !/^[0-9]*$/.test(this.approve.approveThreshold)) || (this.setApproveType === EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE && !/^[0-9]*$/.test(this.approve.monthlyLimit)))) {
        $.toast('请输入正确的审批限额')
        return false
      }
      return true
    },
    resetWindow () {  // ios 兼容，键盘收起后界面下移恢复
      setTimeout(() => {
        window.scrollTo(0, 0)
        console.log('reset invoked')
      }, 300)
    }
  }
}
</script>
<style scoped>
.chooose_group {
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.layerWrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10600;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  opacity: 1;
  -webkit-transition-duration: 400ms;
  -o-transition-duration: 400ms;
  transition-duration: 400ms;
}

.group_3 {
  display: flex;
  /*position: absolute;*/
  /*top: 60vw;*/
  /*left: 13.33vw;*/
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 73.33vw;
  height: 73.6vw;
  z-index: 10601;
}

.infoWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 73.07vw;
}

.info {
  opacity: 1;
  max-width: 69.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 6.67vw;
  white-space: nowrap;
  color: #424242;
  font-size: 4.8vw;
  font-weight: bold;
}

.block_approve {
  display: flex;
  flex-direction: row;
  margin-top: 4.8vw;
  padding-left: 17.86vw;
}

.info_2 {
  opacity: 1;
  margin-left: 1.87vw;
  max-width: 47.47vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #929292;
  font-size: 4.27vw;
  font-weight: 400;
}

.group {
  display: flex;
  flex-direction: row;
  /* margin-top: 5.6vw; */
  /* margin-left: 17.86vw; */
  align-items: center;
}

.block_tagWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 6.67vw;
  width: 73.07vw;
}

.tagWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  height: 13.33vw;
  margin: 0 10px;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.tag {
  opacity: 1;
  text-align: center;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}
.inputWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: 3.47vw;
  border-width: 1px;
  border-style: solid;
  border-radius: 1.33vw;
  border-color: rgba(146, 146, 146, 1);
  background-color: #ffffff;
  /* padding-right: 2.4vw;
  padding-left: 2.4vw; */
  height: 7.47vw;
}

.input_text {
  opacity: 1;
  text-align: center;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.3vw;
  font-weight: 400;
  width: 23vw;
  outline: none;
  border: none;
  padding: 0;
}
label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
  background: no-repeat center;
  background-image: url('/static/img/tick.png');
  background-size: .6rem .45rem;
}

label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
}

label.label-checkbox input[type=radio]:checked+.item-media .info_2 {
  opacity: 1;
  margin-left: 1.87vw;
  max-width: 47.47vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #5878fa;
  font-size: 4.27vw;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// ChooseApproveType2.vue?0c33931b